<template>
  <div id="app" :style="{ paddingBottom: iPhoneX ? '12px' : '0' }">
    <Toast />
    <router-view v-if="this.isShow"></router-view>
  </div>
</template>

<script>
import nr from "nr";
import bus from "./assets/js/common/bus.js";
import { getDateInfo } from "./assets/js/api/rank.js";

const api = nr.loadScript("login");
const cookie = nr.loadScript("cookie");

export default {
  name: "app",
  data() {
    return {
      iPhoneX: false,
      isShow: false,
    };
  },
  created() {
    api.user.info.getUser((result) => {
      this.isShow = true;
      if (result === -999) {
        localStorage.setItem("NEWRANK_USER", "");
        localStorage.setItem("NEWRANK_INFO", "");
        cookie.setCookie("sevFlag", "0");
        bus.$emit("setUser");
      } else {
        const info = {
          bangdou: result.bangdou,
          subscribe: result.subscribe,
          wxName: result.weixiname,
        };
        localStorage.setItem("NEWRANK_USER", JSON.stringify(result.user));
        localStorage.setItem("NEWRANK_INFO", JSON.stringify(info));
        bus.$emit("setUser");
        if (result.user.roles.indexOf("1375") > -1) {
          cookie.setCookie("sevFlag", "1");
        } else {
          cookie.setCookie("sevFlag", "0");
        }
      }
    });
    getDateInfo((res) => {
      const {
        WEIXIN_CAL_DAY,
        WEIXIN_CAL_WEEK,
        WEIXIN_CAL_MONTH,
        PGC_CAL_WEEK,
        TAO_UPDATE_DAY,
        TAO_UPDATE_WEEK,
        TAO_UPDATE_MONTH,
        DOUYIN_CAL_DAY,
        DOUYIN_CAL_WEEK,
      } = res;
      localStorage.setItem("wechatDay", WEIXIN_CAL_DAY);
      localStorage.setItem("wechatWeek", WEIXIN_CAL_WEEK);
      localStorage.setItem("wechatMonth", WEIXIN_CAL_MONTH);
      localStorage.setItem("pgcWeek", PGC_CAL_WEEK);
      localStorage.setItem("taoDay", TAO_UPDATE_DAY);
      localStorage.setItem("taoWeek", TAO_UPDATE_WEEK);
      localStorage.setItem("taoMonth", TAO_UPDATE_MONTH);
      localStorage.setItem("tiktokDay", DOUYIN_CAL_DAY);
      localStorage.setItem("tiktokWeek", DOUYIN_CAL_WEEK);
    });
  },
  mounted() {
    if (this.isIphoneX()) {
      this.iPhoneX = true;
    }
  },
  methods: {
    isIphoneX() {
      return (
        /iPhone/g.test(navigator.userAgent) &&
        screen.height == 812 &&
        screen.width == 375
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// App.vue?6b3860a0